<div class="side-bar">
    side bar works
</div>
